// extracted by mini-css-extract-plugin
export default {"line":"SemisterResultActivitySelector_line__FLeQB"};